import { render, staticRenderFns } from "./subColloct.vue?vue&type=template&id=5091949e&"
import script from "./subColloct.vue?vue&type=script&lang=js&"
export * from "./subColloct.vue?vue&type=script&lang=js&"
import style0 from "./subColloct.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports